import { create } from "zustand";
import API from "../axios/API";

const getBadgeData = async () => {
  try {
    const { data } = await API.get("/achievements/new-badges/");
    if (data && data.new_badges.length > 0) {
      return data;
    }
    return null;
  } catch (error) {
    return null;
  }
};

const getAgeGateData = async () => {
  try {
    const { data } = await API.get("/users/age-gating-info/");
    return data;
  } catch (error) {
    return null;
  }
};

const initialState = {
  snackText: null,
  snackType: null,
  submissionInfo: null,
  showRegisterModal: false,
  showRecommendAppModal: false, // need to redo the check
  showUploadModal: false,
  showEditInfoModal: false,
  badgeData: null, // test the badge data
  showFeaturedBrandsDrawer: false,
};

const useGlobalStore = create((set, get) => ({
  ...initialState,

  initGlobalStore: () => {
    get().queryBadgeData();
    get().queryAgeGateData();
  },
  setSnackText: (text, type) => {
    set({
      snackText: text,
      snackType: type,
    });
  },
  clearSnackText: () => {
    set({
      snackText: null,
      snackType: null,
    });
  },
  clearSubmissionInfo: () => {
    set({
      submissionInfo: null,
    });
  },
  setSubmissionInfo: (id, logo) => {
    set({
      submissionInfo: {
        id,
        logo,
      },
    });
  },
  openRegisterModal: () => {
    set({
      showRegisterModal: true,
    });
  },
  closeRegisterModal: () => {
    set({
      showRegisterModal: false,
      showFeaturedBrandsDrawer: true,
    });
  },
  closeRecommendAppModal: () => {
    set({
      showRecommendAppModal: false,
    });
  },
  openEditInfoModal: () => {
    set({
      showEditInfoModal: true,
    });
  },
  closeEditInfoModal: () => {
    set({
      showEditInfoModal: false,
    });
  },
  clearBadgeData: () => {
    set({
      badgeData: null,
    });
  },

  toggleFeaturedBrandsDrawer: () => {
    set({
      showFeaturedBrandsDrawer: !get().showFeaturedBrandsDrawer,
    });
  },

  queryBadgeData: async () => {
    const data = await getBadgeData();
    set({
      badgeData: data,
    });
  },
  queryAgeGateData: async () => {
    const data = await getAgeGateData();
    if (data?.ask_for_age_gating_info) {
      set({
        showEditInfoModal: true,
      });
    }
  },
}));

export default useGlobalStore;
